import { render, staticRenderFns } from "./detailproducto.vue?vue&type=template&id=2c10907f&"
import script from "./detailproducto.vue?vue&type=script&lang=js&"
export * from "./detailproducto.vue?vue&type=script&lang=js&"
import style0 from "./detailproducto.vue?vue&type=style&index=0&id=2c10907f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports